/** Reverse geocode: convert lat/lng to address using Nominatim */
export async function reverseGeocode(lat, lng) {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`,
      { headers: { "Accept-Language": "en" } }
    );
    const data = await res.json();
    return data?.display_name || `${lat.toFixed(4)}, ${lng.toFixed(4)}`;
  } catch (e) {
    console.error("Reverse geocode failed:", e);
    return `${lat.toFixed(4)}, ${lng.toFixed(4)}`;
  }
}
